function isExpired(expires:string | number | Date) {
  const expirationDate:any = new Date(expires);
  const now:any = new Date();
  return now - expirationDate >= 0;
}
let apiEnv:any = null;
function getKey(key:string) {
  return `${key}_h5_${process.env.REACT_APP_ENV}`;
}

class Storage {
  static getItem(key:string) {
    const storageVal = localStorage.getItem(getKey(key));
    if (storageVal) {
      const data = JSON.parse(storageVal);
      if (data.expires && isExpired(data.expires as (string | number | Date))) {
        this.removeItem(key);
        return null;
      }
      return data.val;
    }
    return null;
  }

  static removeItem(key:string) {
    return localStorage.removeItem(getKey(key));
  }

  static setItem(key:string, val:any, expirationDate?:string | number | Date) {
    if (val !== undefined) {
      const data = {
        expires: expirationDate && (expirationDate as any).toGMTString(),
        val,
      };
      return localStorage.setItem(getKey(key), JSON.stringify(data));
    }
    return undefined;
  }

  static setApiEnv(env:string) {
    apiEnv = env;
  }
}

export default Storage;
